export default "__VITE_ASSET__D1bga$U1__"